<template>

  <section class="hero">

    <!--    <canvas id="scene"></canvas>-->
    <!--    <input id="co py" type="text" value="METARISING"/>-->

    <div class="w-full relative h-screen bg-black">

      <!-- lights     -->
      <canvas id="lights"></canvas>


      <!-- hero bg     -->
      <div class="hero-bg">


        <!--  sky        -->
        <div class="sky">
          <img src="@/assets/images/pages/hero/skyBg.png" alt="" class="hero-img lg:block hidden">
          <img src="@/assets/images/pages/hero/mSkyBg.png" alt="" class="hero-img block lg:hidden">
        </div>

        <!--  cloud        -->
        <div class="cloud"
             :style="{backgroundImage: `url('${$store.state.windowWidth > 1024 ? require('@/assets/images/pages/hero/cloud.png') : require('@/assets/images/pages/hero/mCloud.png')}')`}">
        </div>


        <!--  background tree        -->
        <div class="bg-tree">
          <img class="hero-img bg-tree lg:block hidden" src="@/assets/images/pages/hero/backgroundTree.png" alt="">
          <img class="hero-img bg-tree block lg:hidden" src="@/assets/images/pages/hero/mBackgroundTree2.png" alt="">
        </div>


        <!--  ground        -->
        <div class="ground">
          <img class="hero-img lg:block hidden" src="@/assets/images/pages/hero/ground.png" alt="">
          <img class="hero-img block lg:hidden" src="@/assets/images/pages/hero/mGround2.png" alt="">
        </div>


        <!--  main tree        -->
        <div class="main-tree">
          <img src="@/assets/images/pages/hero/tree3.png" alt="" class="hero-img lg:block hidden">
          <img src="@/assets/images/pages/hero/mTree2.png" alt="" class="hero-img block lg:hidden">
        </div>


        <!-- lights         -->
        <div class="lights">
          <img class="hero-img lg:block hidden" src="@/assets/images/pages/hero/lights.png" alt="">
          <img class="hero-img lg:hidden block" src="@/assets/images/pages/hero/mLights.png" alt="">
        </div>


        <!--   grass       -->
        <div class="grass">
          <img class="hero-img grass lg:block hidden" src="@/assets/images/pages/hero/grass.png" alt="">
          <img class="hero-img grass block lg:hidden" src="@/assets/images/pages/hero/mGrass.png" alt="">
        </div>


        <!--   title       -->
        <div class="title z-50">
          <img class="hero-img lg:block hidden" src="@/assets/images/pages/hero/title.svg" alt="">
          <img class="hero-img block lg:hidden" src="@/assets/images/pages/hero/mTitle.svg" alt="">
        </div>


        <!--  scroll down      -->
        <div class="scroll-down"
             :class="$store.state.scrollY > 50 || $store.state.layoutScrollY > 50 ? 'on' : ''"
        >
          <div class="pb-12">
            {{ $t('hero.1') }}
          </div>
          <div class="blex">
            <div class="w-full blex">
              <img src="@/assets/images/pages/hero/bottomArrow.svg" class="arrow1">
            </div>
            <div class="w-full blex">
              <img src="@/assets/images/pages/hero/bottomArrow.svg" class="arrow2">
            </div>
            <div class="w-full blex">
              <img src="@/assets/images/pages/hero/bottomArrow.svg" class="arrow3">
            </div>
          </div>
        </div>

      </div>

    </div>
  </section>

</template>

<script>
import {Power1} from 'gsap'
import Blinks from './libs/blinks'
import {Ticker} from '@createjs/easeljs'

export default {
  name: 'Hero',
  data: () => ({
    blinks: null,
    timeline: null,
    imageCount: 0,
    loadedImageCount: 0
  }),
  methods: {
    moveMouse (event) {
      if (this.$store.state.windowWidth > 1024) {
        const position = {
          x: (event.clientX / window.innerWidth) - 0.5,
          y: (event.clientY / window.innerHeight) - 0.5
        }

        this.$gsap.to('.hero-img.grass', {
          rotationY: position.x * 10,
          rotationX: position.y * 40,
          ease: Power1.easeOut
        })
        this.$gsap.to('.hero-img.bg-tree', {
          rotationY: position.x * 5,
          rotationX: position.y * 20,
          ease: Power1.easeOut
        })
      }
    },
    updateCanvas () {
      this.blinks.render()
    },
    resizeCanvas () {
      this.blinks.resize()
    },
    animations () {
      this.$gsap.fromTo('.hero-bg', {
        scale: 3
      }, {
        scale: 1
      })
      const startBlur = {a: 20}
      this.$gsap.to('.title', {
        onUpdate: () => {
          this.$gsap.set('.title', {
            webkitFilter: 'blur(' + startBlur.a + 'px)',
            filter: 'blur(' + startBlur.a + 'px)'
          })
          startBlur.a--
        },
        duration: 12
      })
      this.$gsap.to('.lights', {
        opacity: 0.7,
        yoyo: true,
        repeat: -1,
        duration: 1
      })
      window.addEventListener('mousemove', this.moveMouse)
      this.blinks = new Blinks('lights', {
        settings: {
          small: {
            num: this.$store.state.windowWidth > 1024 ? 10 : 12
          },
          medium: {
            num: this.$store.state.windowWidth > 1024 ? 20 : 6
          },
          large: {
            num: this.$store.state.windowWidth > 1024 ? 20 : 6
          }
        },
        lights: [
          {
            ellipseWidth: this.$store.state.windowWidth / 3,
            ellipseHeight: this.$store.state.windowHeight / 10,
            alpha: 0.01,
            offsetX: 0,
            color: '#d3d3d3'
          }
        ]
      })
      Ticker.addEventListener('tick', this.updateCanvas)
      window.addEventListener('resize', this.resizeCanvas, false)

    }
  },
  watch: {
    loadedImageCount (val) {
      // if (this.imageCount === val && this.$scrollTrigger) {
      //   this.$scrollTrigger.refresh()
      // }
    }
  },
  mounted () {
    const images = this.$el.querySelectorAll('img')
    this.imageCount = images.length
    images.forEach(img => {
      if (img.complete) {
        this.loadedImageCount++
      } else {
        img.addEventListener('load', () => this.loadedImageCount++)
      }
    })
  },
  beforeDestroy () {
    window.removeEventListener('mousemove', this.moveMouse)
  }
}
</script>

<style scoped lang="scss">
section::v-deep {

  .cloud {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 0;
    background: 0% 0% repeat;
    background-size: cover;
    animation-name: move-bg;
    animation-duration: 50s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    @media screen and (max-width: 1024px) {
      height: 100%;
    }
  }

  @keyframes move-bg {
    0% {
      background-position: 0 0;
    }

    100% {
      background-position: 100vw 0;
    }
  }

  .grass {
    transform: scale(1.1);
    @media screen and (max-width: 1024px) {
      transform: scale(1);
    }
  }

  @keyframes pulse {
    0% {
      opacity: 0;

    }
    50% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }

  }

  .particle {
    background-color: transparent;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }


  .hero-bg {

    //position: relative;
    //display: flex;
    //justify-content: center;
    //align-items: center;
    //width: 100%;
    //height: 100vh;
    //background-image: url("~@/assets/images/pages/main/hero/heroBg.png");
    //background-position: center;
    //background-repeat: no-repeat;
    //background-size: cover;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;

    @media screen and (max-width: 1024px) {

    }


    .metarising {
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      align-content: center;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      @media screen and (max-width: 1024px) {
        width: 224px;

      }

    }

    .scroll-down {
      position: absolute;
      font-weight: 400;
      color: #fff;
      font-size: 0.938vw;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, -80%);
      opacity: 1;
      transition: all 1s;

      .arrow1 {
        animation: pulse 1.5s 1s linear infinite;
      }

      .arrow2 {
        animation: pulse 1.5s 1.5s linear infinite;
      }

      .arrow3 {
        animation: pulse 1.5s 2s linear infinite;
      }

      &.on {
        opacity: 0;
        transition: all 1s;
      }

      @media screen and(max-width: 1024px) {
        font-size: 14px;
      }
    }
  }

  #lights {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 140%;
    z-index: 2;
  }

  input {
    letter-spacing: 1.3px;
    width: 200px;
    height: 40px;
    line-height: 40px;
    position: absolute;
    bottom: 35px;
    left: calc(50% - 125px);
    background: none;
    font-size: 1rem;
    font-family: arial;
    text-align: center;
    border: none;
    border-bottom: 1px solid rgb(187, 187, 187);
    outline: none;
    background: rgba(255, 255, 255, 0);
    color: rgb(189, 189, 189);
  }

  .hero-img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    @media screen and (max-width: 1024px) {
      object-fit: cover;
      height: 100vh;

    }
  }
}

</style>
